function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 17.0786C16 13.7215 18.7215 11 22.0786 11H119.921C123.279 11 126 13.7215 126 17.0786V114.921C126 118.279 123.279 121 119.921 121H22.0786C18.7215 121 16 118.279 16 114.921V17.0786Z",
  fill: "#E5F6EE"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.5 105V68C5.5 63.5817 9.08172 60 13.5 60H41",
  stroke: "#003311",
  strokeWidth: 2,
  strokeDasharray: "2 4"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.30218 99H1.69922V106.603H9.30218V99Z",
  fill: "#22EE88",
  stroke: "#003311",
  strokeWidth: 2.27947,
  strokeMiterlimit: 10
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M97.5 60H125C129.418 60 133 56.4183 133 52V24",
  stroke: "#003311",
  strokeWidth: 2
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 117,
  width: 32,
  height: 32,
  rx: 5.12,
  fill: "#003311"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M133.305 5.97842C127.593 5.97842 122.945 10.6256 122.945 16.3384C122.945 22.0512 127.593 26.6984 133.305 26.6984C139.018 26.6984 143.665 22.0512 143.665 16.3384C143.665 10.6256 139.014 5.97842 133.305 5.97842ZM133.305 25.9584C128 25.9584 123.685 21.6442 123.685 16.3384C123.685 11.0326 128 6.71842 133.305 6.71842C138.611 6.71842 142.925 11.0326 142.925 16.3384C142.925 21.6442 138.611 25.9584 133.305 25.9584Z",
  fill: "#22EE88"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M135.632 12.3758L133.305 14.7031L130.977 12.3758H130.456L129.346 13.4858V14.0075L131.673 16.3348L129.346 18.6621V19.1838L130.456 20.2938H130.977L133.305 17.9665L135.632 20.2938H136.154L137.264 19.1838V18.6621L134.936 16.3348L137.264 14.0075V13.4858L136.154 12.3758H135.632ZM134.152 16.0758V16.5975L136.479 18.9248L135.891 19.5131L133.564 17.1858H133.042L130.715 19.5131L130.126 18.9248L132.454 16.5975V16.0758L130.126 13.7485L130.715 13.1602L133.042 15.4875H133.564L135.891 13.1602L136.479 13.7485L134.152 16.0758Z",
  fill: "#22EE88"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M132.083 13.9574L131.258 13.2349C130.968 12.9814 130.54 12.9653 130.232 13.1963C129.835 13.4938 129.794 14.0737 130.145 14.4243L130.851 15.131C131.508 15.7876 131.508 16.8523 130.851 17.509L130.145 18.2157C129.794 18.5663 129.835 19.1462 130.232 19.4437C130.54 19.6747 130.968 19.6586 131.258 19.4051L132.083 18.6825C132.792 18.0627 133.849 18.0627 134.558 18.6825L135.37 19.393C135.657 19.6445 136.09 19.6301 136.36 19.36C136.631 19.0899 136.645 18.6566 136.393 18.3691L135.683 17.5572C135.063 16.8488 135.063 15.7911 135.683 15.0828L136.393 14.2709C136.645 13.9834 136.631 13.5501 136.36 13.28C136.09 13.0099 135.657 12.9955 135.37 13.247L134.558 13.9574C133.849 14.5773 132.792 14.5773 132.083 13.9574Z",
  fill: "#22EE88"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M116 94.5889L109.757 85.7694C105.992 80.4594 103.972 74.1119 103.972 67.6118V47.8062C103.972 31.6321 92.0361 18.2046 76.458 15.8548V6.36394C76.458 3.95309 74.4993 2 72.0815 2C69.6637 2 67.705 3.95309 67.705 6.36394V15.6717C51.576 17.5637 39.0891 31.2049 39.0891 47.8062V68.3442C39.0891 75.3936 36.7325 82.26 32.3559 87.8141L27 94.6194H116V94.5889Z",
  fill: "#22EE88"
});

var _ref11 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_4867_1651)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M116 94.5889L109.757 85.7694C105.992 80.4594 103.972 74.1119 103.972 67.6118V47.8062C103.972 31.6321 92.0361 18.2046 76.458 15.8548V6.36394C76.458 3.95309 74.4993 2 72.0815 2C69.6637 2 67.705 3.95309 67.705 6.36394V15.6717C51.576 17.5637 39.0891 31.2049 39.0891 47.8062V68.3442C39.0891 75.3936 36.7325 82.26 32.3559 87.8141L27 94.6194H116V94.5889Z",
  fill: "#00AA55"
}));

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M66.8167 108.993C71.6217 111.007 77.5285 109.969 81.3848 106.491C83.0681 104.965 84.3229 103.012 85.0574 100.875L59.1348 100.692C60.4202 104.354 63.2359 107.498 66.8167 108.993Z",
  fill: "#00AA55"
});

var _ref13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_4867_1651"
}, /*#__PURE__*/React.createElement("rect", {
  width: 45,
  height: 93,
  fill: "white",
  transform: "translate(27 2)"
})));

var SvgNotification = function SvgNotification(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 121,
    viewBox: "0 0 149 121",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotification, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notification.6dfe2f75.svg";
export { ForwardRef as ReactComponent };